import React, {memo, useEffect} from "react";
import BaseModal from "./../BaseModal";
import {useDispatch, useSelector} from "react-redux";
import {
    actionLoaderProductsModalShoppingCard, actionRemoveItemInBasketCart, actionSetApiCardsModalShoppingCard,
    handelCloseModalShoppingCard
} from "../../../../../redux/actions/modals/modalShoppingCard";

import FooterModalShoppingCard from "./FooterModalShoppingCard";
import BodyModalShoppingCard from "./BodyModalShoppingCard";
import {CSSTransition, SwitchTransition} from "react-transition-group";

import {Modal} from "react-bootstrap";
import {actionRefreshModalAddDiscountCode} from "../../../../../redux/actions/modals/modalAddDiscountCode";
import _ from "lodash";
import qs from "querystring";
import axios from "axios";
import {BASE_URL, ORDERS_BASKET_POST} from "../../../../../apis";
import {useRouteMatch} from "react-router-dom";
import {actionLogOutUser} from "../../../../../redux/actions/user/user";


const ModalShoppingCard = () => {
    const dispatch = useDispatch();
    const match = useRouteMatch();
    const {
        statusShow,
        titleModalShoppingCard,
        statusAnimation,
        statusPrevAndNext
    } = useSelector(state => state.modalShoppingCard);
    const {token, activeAddress} = useSelector(state => state.user);
    const {loaderListProducts} = useSelector(state => state.modalShoppingCard);
    const {carts} = useSelector(state => state.shoppingCart);
    const store = useSelector(state => state.stores.list_stores.find(storeItem => storeItem.id === match.params.store));

    const handleClose = () => {
        dispatch(handelCloseModalShoppingCard());
        dispatch(actionRefreshModalAddDiscountCode());
    };

    const apiHandelSendProductToServer = async () => {
        try {
            let data = {address: activeAddress.addressId, store: store.id};

            const basket_products = _(carts).mapKeys(cart => `basket_products[${cart.grades[0].gradeId}]`)
                .mapValues(cart => cart.w_numbers).value();

            const options = _(carts).filter(cart => cart.optionSelect).mapKeys(cart => `options[${cart.grades[0].gradeId}]`)
                .mapValues(cart => cart.w_numbers).value();

            data = qs.stringify(_.assign(data, basket_products, options));

            if (!loaderListProducts) {
                dispatch(actionLoaderProductsModalShoppingCard(true));
            }

            const response = await axios.post(BASE_URL + ORDERS_BASKET_POST, data,
                {headers: {'Authorization': token}}
            );

            if (response.data.status === 'ok') {
                dispatch(actionSetApiCardsModalShoppingCard(response.data));
                Object.keys(response.data.basket).forEach((key) => {
                    if (!response.data.basket[key].status) {
                        dispatch(actionRemoveItemInBasketCart(key));
                    }
                });
            } else if (response.data.status === 're_login') {
                handleClose();
                dispatch(actionLogOutUser());
            }
        } catch (e) {
            console.log(e);
        } finally {
            dispatch(actionLoaderProductsModalShoppingCard(false));
        }
    };

    useEffect(() => {
        if (statusShow) {
            apiHandelSendProductToServer();
        }
        // eslint-disable-next-line
    }, [statusShow]);

    return (
        <BaseModal
            title={titleModalShoppingCard}
            show={statusShow}
            handleClose={handleClose}
            dialogClassName={'modal-dialog-shopping-card-custom'}>
            <Modal.Body>
                <SwitchTransition mode={'out-in'}>
                    <CSSTransition
                        key={statusAnimation}
                        addEndListener={(node, done) => {
                            node.addEventListener("transitionend", done, false);
                        }}
                        classNames={statusPrevAndNext === "next" ? "fade-right" : "fade-left"}
                    >
                        <div className={"o-hidden"}>
                            <div className={'anim-base-test'}>
                                <BodyModalShoppingCard/>
                            </div>
                        </div>
                    </CSSTransition>
                </SwitchTransition>
            </Modal.Body>
            {/*Footer*/}
            <FooterModalShoppingCard/>
        </BaseModal>
    )
};

export default memo(ModalShoppingCard);
